/* eslint-disable max-len */
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React, { useState } from 'react';
import PopularArea from '../../../components/PopularArea';
import RecentArea from '../../../components/RecentArea';
import YourLocation from '../../../components/YourLocation';
import SearchInputDialog from '../SearchInputDialog';
import type { SearchDialogProps } from './index.d';
import { style } from '@/styles/globals';

const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: center;
`;
const BackIconWrapper = styled('div')`
  position: absolute;
  left: 1rem;
  top: 20px;
`;

const SearchDialog: React.FC<SearchDialogProps> = ({
  type,
  setClose,
}) => {
  // const point = useAppSelector((state) => (type === 'from'
  //   ? state.searchFlightForm.startPoint
  //   : state.searchFlightForm.toPoint));
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  return (
    <Stack
      sx={{ paddingY: 2 }}
      spacing={2}
    >
      <HeaderWrapper>
        <BackIconWrapper onClick={setClose}>
          <ArrowBackIcon
            style={{
              position: 'absolute',
              color: style.color.black1,
              fontSize: '1.8em',
            }}
          />
        </BackIconWrapper>
        <Typography
          variant="h6"
          sx={{ fontSize: 18 }}
        >
          {type === 'from' ? 'Nơi đi' : 'Nơi đến'}
        </Typography>
      </HeaderWrapper>
      <Stack>
        <SearchInputDialog
          setClose={setClose}
          setIsInputEmpty={setIsInputEmpty}
          type={type}
        />
      </Stack>
      {isInputEmpty && (
        <>
          <YourLocation />
          <RecentArea
            type={type}
            setClose={setClose}
          />
          <PopularArea
            type={type}
            setClose={setClose}
          />
        </>
      )}
    </Stack>
  );
};

export default SearchDialog;
